"use client";

import { Image as ImageType } from "@/types/Image";
import {
  Authenticator,
  Button,
  useAuthenticator,
  useTheme,
  View,
} from "@aws-amplify/ui-react";
import Image from "next/image";

import poweredByTT from "./images/powered_by_TT.svg";

interface AuthFormProps {
  initialState?: AuthFormInitialState;
  logoImage: ImageType;
  onClose: () => void;
}

export type AuthFormInitialState = "signIn" | "signUp" | "forgotPassword";

const AuthForm = (props: AuthFormProps) => {
  const { logoImage } = props;

  return (
    <Authenticator
      variation={"modal"}
      loginMechanisms={["email"]}
      initialState={props.initialState || "signIn"}
      formFields={{
        signUp: {
          given_name: {
            label: "First Name",
            placeholder: "First Name",
            isRequired: true,
          },
          family_name: {
            label: "Last Name",
            placeholder: "Last Name",
            isRequired: true,
          },
        },
      }}
      components={{
        Header() {
          const { tokens } = useTheme();
          return (
            <View
              className="authorize-header"
              style={{
                backgroundColor: `var(--header-background-color, #ffffff)`,
              }}
            >
              {/*TODO: Currently only works for chestnutstreetinn and thevillasatcocoplum,
                 we need to standardize the other logos to also be PNG and not SVG*/}
              <Image
                alt={logoImage.alt}
                src={logoImage.src}
                height={logoImage.height}
                width={logoImage.width}
                style={{ maxWidth: "300px", height: "auto" }}
              />
            </View>
          );
        },
        Footer() {
          const { tokens } = useTheme();
          return (
            <View className="authorize-footer">
              <div>
                <Image
                  alt="Powered by ThinkTravel logo"
                  src={poweredByTT.src}
                  width={176}
                  height={19}
                  style={{ margin: 12 }}
                />
              </div>
              <Button variation="link" onClick={props.onClose}>
                Close
              </Button>
            </View>
          );
        },
        SignUp: {
          FormFields() {
            const { validationErrors } = useAuthenticator();

            return (
              <>
                <Authenticator.SignUp.FormFields />
              </>
            );
          },
        },
      }}
    />
  );
};

export default AuthForm;
